
import { defineComponent, PropType } from 'vue'
import { iValues } from './TargetDefinition'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import InputNumber from 'primevue/inputnumber'
import targetDefinitionDetailDecriptor from './TargetDefinitionDetailDescriptor.json'
export default defineComponent({
    name: 'apply-target-card',
    components: {
        DataTable,
        Column,
        InputNumber
    },
    props: {
        loadingKpi: {
            type: Boolean,
            default: false
        },
        kpi: {
            type: Array as PropType<iValues[]>,
            required: true
        }
    },
    data() {
        return {
            selectedKpi: [] as iValues[],
            targetDefinitionDetailDecriptor: targetDefinitionDetailDecriptor
        }
    },
    watch: {
        kpi() {
            this.selectedKpi = this.kpi
        }
    },
    methods: {
        addKpiDialog() {
            this.$emit('showDialog')
        },
        deleteKpi(selected: iValues) {
            const index = this.selectedKpi.findIndex((selectedKpi) => {
                return selectedKpi.kpiId === selected.kpiId
            })
            if (index >= 0) {
                this.selectedKpi.splice(index, 1)
                this.$emit('kpiChanged', this.selectedKpi)
            }
        }
    }
})
